import Navbar from "components/navigation/Navbar";
import Layout from "hocs/layouts/Layout";
import { useEffect } from "react";
import { motion } from 'framer-motion';
import Footer from "components/navigation/Footer";
import { useParams } from "react-router-dom";
import Cuento from "components/cuentoPage/Cuento";

function CuentoPage() {

    const{ id } = useParams()

    // Scroll to top of page
    useEffect(() => {
        window.scrollTo(0,0);
    }, []);

    return (
        <Layout>
            <Navbar />

            {/* Motion for smooth transition */}
            <motion.div
                initial={{opacity: 0, transition: {duration: 1}}}
                animate={{opacity: 1}}
                exit={{opacity: 0, transition: {duration: 0}}}
            >
                <Cuento id={id} />
            </motion.div>
            

            <Footer />
        </Layout>

    );
}

export default CuentoPage;